import { Modal } from 'antd';
import React, { useState } from 'react';
import { AssetUsersSelectedType } from './AssetUsersSelect';
import AssetUsers from 'pages/Asset/components/AssetUsers';

export type AssetUsersSearchModalProps = {
  visible: boolean;
  onCancel: () => void;
  onSelect?: (Asset: AssetUsersSelectedType) => void;
  ctref?:string
  phase?:any
  id:number
  selectedRowKeys?:boolean
  assetid:number;
};

const AssetUsersSearchModal = ({
  ctref,
  onCancel,
  visible,
  onSelect,
  phase,
  id,
  selectedRowKeys,
  assetid,
}: AssetUsersSearchModalProps) => {

  const [selectedRow, setSelectedRow] = useState<AssetUsersSelectedType | null>(null);

 
  return (
    <Modal 
      visible={visible} 
      onCancel={onCancel} 
      width={1200}
      onOk={() => {
        if (selectedRow && onSelect) {
          onSelect(selectedRow);
        }
        onCancel();
      }}
    >
      <AssetUsers 
        id={assetid} 
        selectedRowKeys={selectedRowKeys} 
        onSelect={(row) => setSelectedRow(row)}
      />
    </Modal>
  );
};

export default AssetUsersSearchModal;
